export default __webpack_public_path__ + "static/media/Animations_Circle4.93bbcc5e.svg";